import { faXmark } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const CrossIcon = () => {
  return <FontAwesomeIcon icon={faXmark} size="lg" color="red" />
}

export default CrossIcon
